__turbopack_context__.v({
  "root": "VpnNotice-module-scss-module__7vM5nq__root",
  "text": "VpnNotice-module-scss-module__7vM5nq__text",
});
